/*
 * flavour-nav.js
 *
 * Normalises the "Jump to flavour" selector on product pages.
 *
 * The section renders the CURRENT product's option straight from its Shopify
 * title ("ChewTeinz Blueberry Protein Gummies - Travel Size (90g)"), while every
 * other option comes from the short name typed on its flavour block
 * ("Sour Watermelon · Travel Size"). The result is one long entry sitting above
 * three short ones, and it changes shape depending which page you are on.
 *
 * This maps every option to a single naming convention, keyed by product handle
 * so it stays correct no matter which page renders the list. Add a product here
 * when you add one to the lineup; anything not listed keeps its Shopify title.
 */
(function () {
    "use strict";

    var NAMES = {
        "chewteinz-sour-watermelon-protein-gummies-travel-size-90g":
            "Sour Watermelon · Travel Size",
        "chewteinz-blueberry-protein-gummies-travel-size-90g-copy":
            "Blueberry · Travel Size",
        "chewteinz-mango-madness-protein-gummies-travel-size-90g-copy":
            "Mango Madness · Travel Size",
        "chewteinz-mango-madness": "Mango Madness · 180g",
        "chewteinz-mango-madness-3-pack": "Mango Madness · 3-Pack",
        "chewteinz-mango-madness-10-pack": "Mango Madness · 10-Pack"
    };

    function handleOf(value) {
        var match = String(value || "").match(/\/products\/([^/?#]+)/);
        return match ? match[1] : "";
    }

    function apply() {
        var options = document.querySelectorAll(
            "select[data-ct-product-jump] option"
        );
        Array.prototype.forEach.call(options, function (option) {
            var name = NAMES[handleOf(option.value)];
            if (!name) return;
            // Keep the " - soon" marker the section appends to unreleased flavours.
            var suffix = / - soon$/.test(option.textContent) ? " - soon" : "";
            option.textContent = name + suffix;
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", apply);
    } else {
        apply();
    }
})();
